<template>
  <layout-base maxWidth="100%" margin="0 0" style="font-size: 13px;" align="left" id="gtr-emails-html">
    <layout-block margin="0px 0px">
      <div v-html="email.data.first_section"></div>
    </layout-block>
    <layout-block
      v-if="email.type !== 'lead_first_email'"
      style="display: flex; align-items: center;"
      margin="18px 0px"
    >
      <img
        style="margin-right:12px"
        width="44px"
        height="44px"
        src="https://gatoreviews.s3.eu-west-3.amazonaws.com/common/emails/new/information.png"
      />
      <div v-html="email.data.alert_section"></div>
    </layout-block>
    <layout-block
      v-if="email.type === 'dealer_first_reminder'"
      style="display:table;border-collapse: separate;border-spacing: 16px 0;width:400px;"
      margin="0 0"
    >
      <lead-button
        v-for="(cta, index) in email.data.ctas"
        :key="`cta ${index}`"
        :label="cta.label"
        :href="cta.url"
        margin="0px 10px"
        :bg-type="cta.type"
      ></lead-button>
    </layout-block>
    <lpe-message margin="18px 0px" :content="email.data.message"></lpe-message>
    <layout-block v-if="email.data.second_section" margin="0px 0px">
      <div v-html="email.data.second_section"></div>
    </layout-block>
    <layout-block margin="0px 0px">
      <div v-html="email.data.last_section"></div>
    </layout-block>
    <br />
    <layout-block style="font-size: 12px" margin="0px 0px">
      <div v-html="email.data.footer"></div>
    </layout-block>
  </layout-base>
</template>

<script>
import LayoutBase from '@/components/Layout/Base.vue'
import LayoutBlock from '@/components/Layout/Block.vue'
import LpeMessage from '@/components/Lpe/Message.vue'
import LeadButton from '@/components/UI/LeadButton.vue'

export default {
  name: 'lpe-lead-first',
  components: {
    LayoutBase,
    LayoutBlock,
    LpeMessage,
    LeadButton,
  },
  props: {
    email: {
      type: Object,
      required: true,
    },
  },
}
</script>
